export function getToday() {
    const today = new Date();
    return new Date(today.getFullYear(), today.getMonth(), today.getDate());
}

export function getWeekBounds() {
    const today = getToday();
    const date = today.getDate() - today.getDay();

    const start = new Date(today.setDate(date));
    const end = new Date(today.setDate(date + 6));
    return [start, end];
}

export function getLastMonthBounds() {
    const start = getToday();
    start.setDate(1);
    start.setMonth(start.getMonth() - 1);

    const end = getToday();
    end.setDate(0);

    return [start, end];
}

export function relativeToday(val = 0) {
    const today = getToday();
    today.setDate(today.getDate() + val);
    return today;
}

export function getStartOfWeek() {
    return getWeekBounds()[0];
}

export function getEndOfWeek() {
    return getWeekBounds()[1];
}

export function getStartOfMonth() {
    const today = getToday();
    return new Date(today.getFullYear(), today.getMonth());
}

export function getStartOfLastMonth() {
    return getLastMonthBounds()[0];
}

export function getEndOfLastMonth() {
    return getLastMonthBounds()[1];
}

const dateStrRegex = /^(\w{3})\s(\w{3})\s(\d{2})\s(\d{4})$/;
export function getDateStrJSON(date) {
    const str = date.toDateString();
    const matches = str.match(dateStrRegex);

    return {
        weekDay: matches[1],
        month: matches[2],
        day: matches[3],
        year: matches[4],
    };
}
